import { Component, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

/**
 * Displays an empty-state UI for location lists and provides a control to trigger adding a new location.
 * This lightweight presentational component is shown when there are no saved locations and emits an event to request creation of a new location.
 * Key methods:
 *   - onAddLocation(): Invoked by the template/user interaction; emits the addLocation output event.
 * Lifecycle hooks:
 *   - None used; the component does not implement any Angular lifecycle hooks.
 * @component
 * @selector app-empty-location
 * @example
 *   <app-empty-location (addLocation)="handleAddLocation()"></app-empty-location>
 * @input none - This component does not accept any input properties.
 * @output EventEmitter<void> addLocation - Emitted when the user requests to add a new location (no payload).
 */
@Component({
  selector: 'app-empty-location',
  imports: [],
  templateUrl: './empty-location.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './empty-location.component.scss',
})
export class EmptyLocationComponent {
  @Output() addLocation = new EventEmitter<void>();

  onAddLocation() {
    this.addLocation.emit();
  }
}
